import { createFileRoute } from '@tanstack/react-router'
import CatalogPage from '@/pages/catalog-gen'

export const Route = createFileRoute('/catalog-gen')({
  component: CatalogPage,
})
